import React from "react";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import { toTitleCase } from "../../../../Utils/stringUtls";
import {
  inHouseDevelopmentTeamOptions,
  pullApiOptions,
  sendPushNotificationOptions,
} from "../../WebAPIs/stringUtils";

const WebServicesAPIOverview = ({ data }) => {
  if (!data) return <DataNotFound />;

  const pullData = data["6_0"] || {};
  const pushData = data["6_1"] || {};

  const {
    web_services_pull_api_select_version_of_pull_api_you_would_like_to_opt_from_i2c,
    web_services_pull_api_do_you_have_an_in_house_development_team,
    web_services_pull_api_confirm_if_third_party_vendor_is_pci_compliant,
  } = pullData;

  const {
    web_services_push_api_would_you_like_i2c_push_notification_to_send_notification_to_your_preferred_channels,
    web_services_push_api_please_confirm_channel_to_send_push_notification,
    web_services_push_api_please_confirm_channel_to_send_push_notification_other,
  } = pushData;

  return (
    <React.Fragment>
      <div className="forms-instance" style={{ color: "#111" }}>
        <div i2c-grid="grid grid" className="review-summary-gap">
          <div i2c-grid="12@md" className="review-summary-sub-heading">
            <div className="fw-700 font-bold">Pull APIs</div>
          </div>
          <ReviewAttribute
            label="Please select version of Pull API you would like to opt from i2c"
            value={
              web_services_pull_api_select_version_of_pull_api_you_would_like_to_opt_from_i2c?.length
                ? pullApiOptions.find(
                    (option) =>
                      option.value ===
                      web_services_pull_api_select_version_of_pull_api_you_would_like_to_opt_from_i2c,
                  )?.label ||
                  toTitleCase(
                    web_services_pull_api_select_version_of_pull_api_you_would_like_to_opt_from_i2c,
                  )
                : "-"
            }
          />
          <ReviewAttribute
            label="Do you have an In-house development team?"
            value={
              web_services_pull_api_do_you_have_an_in_house_development_team?.length
                ? inHouseDevelopmentTeamOptions.find(
                    (option) =>
                      option.value ===
                      web_services_pull_api_do_you_have_an_in_house_development_team,
                  )?.label ||
                  toTitleCase(
                    web_services_pull_api_do_you_have_an_in_house_development_team,
                  )
                : "-"
            }
          />
          {web_services_pull_api_do_you_have_an_in_house_development_team ===
            "no" && (
            <ReviewAttribute
              label="Confirm if 3rd Party Vendor is PCI Compliant"
              value={
                web_services_pull_api_confirm_if_third_party_vendor_is_pci_compliant?.length
                  ? toTitleCase(
                      web_services_pull_api_confirm_if_third_party_vendor_is_pci_compliant,
                    )
                  : "-"
              }
            />
          )}
        </div>
        <div className="divider-bottom mt-16 mb-16"></div>
      </div>
      <div className="forms-instance" style={{ color: "#111" }}>
        <div i2c-grid="grid grid" className="review-summary-gap">
          <div i2c-grid="12@md" className="review-summary-sub-heading">
            <div className="fw-700 font-bold">Push APIs</div>
          </div>
          <ReviewAttribute
            label="Please select if you would like to use i2c's Push APIs to send notifications to your preferred channels."
            value={
              web_services_push_api_would_you_like_i2c_push_notification_to_send_notification_to_your_preferred_channels?.length
                ? toTitleCase(
                    web_services_push_api_would_you_like_i2c_push_notification_to_send_notification_to_your_preferred_channels,
                  )
                : "-"
            }
          />
          {web_services_push_api_would_you_like_i2c_push_notification_to_send_notification_to_your_preferred_channels ===
            "yes" && (
            <ReviewAttribute
              label="Please confirm channel to send push notification"
              value={
                web_services_push_api_please_confirm_channel_to_send_push_notification ===
                "other"
                  ? web_services_push_api_please_confirm_channel_to_send_push_notification_other ||
                    "-"
                  : web_services_push_api_please_confirm_channel_to_send_push_notification?.length
                    ? sendPushNotificationOptions.find(
                        (option) =>
                          option.value ===
                          web_services_push_api_please_confirm_channel_to_send_push_notification,
                      )?.label ||
                      toTitleCase(
                        web_services_push_api_please_confirm_channel_to_send_push_notification,
                      )
                    : "-"
              }
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default WebServicesAPIOverview;
